import React from 'react'
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import {Outlet} from "react-router-dom";
const ReportsPage = () => {
    return(<React.Fragment>
        <DashboardLayout>
            <Outlet/>
        </DashboardLayout>
    </React.Fragment>)
}

export default ReportsPage